<template>
  <div id="smartTown">
    <div class="title">医院智慧服务分级评估标准体系（试行）</div>
    <div class="text">（一）建立完善医院智慧服务现状评估和持续改进体系，评估医院开展的智慧服务水平。</div>
    <div class="text">（二）明确医院各级别智慧服务应当实现的功能，为医院建设智慧服务信息系统提供指南，指导医院科学、合理、有序地开发、应用智慧服务信息系统。</div>
    <div class="text">（三）引导医院沿着功能实用、信息共享、服务智能的方向，建设完善智慧服务信息系统，使之成为改善患者就医体验、开展全生命周期健康管理的有效工具。</div>
    <div class="btn" @click="toLink()">查看详情</div>
   
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('http://www.nhc.gov.cn/yzygj/s3594q/202103/10ec6aca99ec47428d2841a110448de3.shtml')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be;
  border: 1px solid #1e73be;
}

.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
  text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news6.vue